const Locale = {
  ENGLISH: "en",
  FRENCH: "fr",
};

export default Locale;
